import React, { Component } from "react";
import { notify } from "react-notify-toast";
import { connect } from "react-redux";
import { NavLink } from "react-router-dom";
import { Col, Row } from "reactstrap";
import { bindActionCreators } from "redux";
import createHistory from "history/createBrowserHistory";
import { actionProcessingJobs, updateStatusAction } from "../../actions/index";
import CancelJob from "./CancelJob";
import ClockImage from "../../images/clock.svg";
import api from "../../utility/api/api.js";
import GetTime from "../GetTime.js";
import DelayMinutes from "./DelayMinutes";
import OrderId from "./OrderId";
import AcceptModal from "./AcceptModal";

class PendingJobs extends Component {
  constructor(props) {
    super(props);
    this.state = { acceptData: "", getupdatestatusJob: "" };
    const history = createHistory();
  }
  componentWillMount() {
    api.acceptJobList(this);
  }
  startShiping = (e, job_id) => {
    console.log("IntransitGuna");
    if (this.props.jobs && this.props.jobs !== "failure") {
      notify.show("Please Complete In Progress Trip", "success", 1000);
      e.preventDefault();
      return;
    } else {
      this.props.actionProcessingJobs(null);
      api.updateriderstatus(this, job_id);
      console.log("this.props.statusUpdate", this.state.getupdatestatusJob);
      if (
        this.state.getupdatestatusJob &&
        this.state.getupdatestatusJob == "in-transit"
      ) {
        api.callShippingJobs(this, job_id);
      }
    }
  };
  cancelShiping = (job_id) => {
    console.log("haha", job_id);
    api.rejectRiderTrip(job_id);
  };
  inCompleteFunction = () => {
    if (this.state.acceptData && this.state.acceptData[0].data.length > 0) {
      this.state.acceptData[0].data.shift();
    }
  };
  render() {
    console.log("acceptDataacceptData", this.state.acceptData);

    const trips = this.props.jobsobject;
    console.log("tripstrips", trips);
    return (
      <div className="spn-jobs">
        {this.state.acceptData &&
        this.state.acceptData[0] &&
        this.state.acceptData[0].status == "success" ? (
          this.state.acceptData &&
          this.state.acceptData[0] &&
          this.state.acceptData[0].data &&
          this.state.acceptData[0].data.length > 0 ? (
            <AcceptModal
              incompletefn={this.inCompleteFunction}
              acctda={this.state.acceptData[0].data[0]}
            />
          ) : null
        ) : null}
      </div>
    );
  }
}
function mapStateToProps(state) {
  console.log("checklistjobs", state);
  return {
    jobs: state.processingJobs,
    statusUpdate: state.getupdateStatus,
  };
}
function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      actionProcessingJobs: actionProcessingJobs,
      updateStatusAction: updateStatusAction,
    },
    dispatch
  );
}
export default connect(mapStateToProps, mapDispatchToProps)(PendingJobs);



// WEBPACK FOOTER //
// ./src/components/Assigned/PendingJobs.js